// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:39:58

export default {
  "id": "pop-party",
  "slug": "pop-party",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/bbe8c72e4ef34096a54361a37096ee86-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/bbe8c72e4ef34096a54361a37096ee86/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Pop Party",
      "description": "Get ready for Pop Party, a fast-paced 2D physics puzzle game with a wild twist! \nYour goal? Merge them to create bigger, better versions before your jar overflows! \n\nPower-Up the Madness!\nTurn the tide of the game with six powerful abilities:\nShake\nLevel Up\nLevel Down\nClaw\nBomb\nColor Bomb\n\nUnlock Stunning Themes!\nProgress through the game and collect unique themes, each transforming the look of your balls:\n\nCan you master the chaos, merge your way to victory, and unlock every theme?",
      "instructions": "Use mouse or touch to interact with in game interface",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "color",
        "colormatch",
        "watermelon"
      ]
    },
    "zh-CN": {
      "title": "泡泡派对",
      "description": "准备迎接《Pop Party》，一款节奏飞快的2D物理益智游戏，并加入疯狂元素！\n\n你的目标是什么？将它们合并，在容器溢出前创造更大、更好的版本！\n\n激发疯狂的力量！\n\n用六种强大的能力扭转游戏局势：\n摇晃\n升级\n降级\n爪子\n炸弹\n彩色炸弹\n\n解锁惊艳主题！\n\n游戏进程，收集独特主题，每个主题都会改变球球的造型：\n\n你能掌控混乱，一路合并直至胜利，解锁所有主题吗？",
      "instructions": "使用鼠标或触摸与游戏界面交互",
      "genres": [
        "休闲",
        "解谜"
      ],
      "tags": [
        "颜色",
        "颜色匹配",
        "西瓜"
      ]
    },
    "zh-TW": {
      "title": "泡泡派對",
      "description": "準備開啟Pop Party！一款節奏快速的2D物理解謎遊戲，帶來狂野的變化！\n你的目標是？將它們合併成更大、更好的版本，在容器溢出之前！\n\n提升瘋狂程度！\n用六種強大的能力扭轉遊戲局面：\n搖晃\n升級\n降級\n爪子\n炸彈\n顏色炸彈\n\n解鎖驚艷主題！\n通過遊戲並收集獨特的主題，每個主題都會改變你的球類的樣貌：\n\n你能掌握混亂，通過合併走向勝利，並解鎖所有主題嗎？",
      "instructions": "使用滑鼠或觸控與遊戲介面互動",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "顏色",
        "顏色匹配",
        "西瓜"
      ]
    },
    "zh-HK": {
      "title": "波普派對",
      "description": "為咗Pop Party，一個節奏快速、2D物理謎題遊戲，帶有狂野變化！\n你的目標係咩？將佢哋合併，創造更大、更好的版本，喺你嘅瓶樽滿嘅之前！\n\n加強瘋狂！\n用六種強大能力轉變遊戲局面：\n搖動\n升級\n降級\n利爪\n炸彈\n顏色炸彈\n\n解鎖驚艷主題！\n通過遊戲並收集獨特主題，每個主題都會變更你嘅球嘅外觀：\n\n你能夠掌握混亂，通過合併嘅方式贏得勝利，並解鎖每個主題嗎？",
      "instructions": "使用滑鼠或觸控互動遊戲介面",
      "genres": [
        "輕鬆",
        "謎題"
      ],
      "tags": [
        "顏色",
        "顏色匹配",
        "西瓜"
      ]
    },
    "ja": {
      "title": "ポップパーティー",
      "description": "Pop Party、速攻の2D物理パズルゲームで、狂ったような要素が加わっています！\nあなたの目標は、壺が満杯になる前に、これらを融合させてより大きく、より良いバージョンを作ることです。\n\n狂気のパワーアップ！\nゲームの流れを変える6つの強力な能力で戦いを進めよう：\n shake（振る）\n Level Up（レベルアップ）\n Level Down（レベルダウン）\n Claw（爪）\n Bomb（爆弾）\n Color Bomb（色爆弾）\n\n素晴らしいテーマを解禁！\nゲームを進めてユニークなテーマを収集し、それぞれでボールの外見が変わります：\n\nこの混沌を制覇し、勝利に向かって融合し、全てのテーマを解禁できるでしょうか？",
      "instructions": "マウスやタッチでゲーム内インターフェースと対話してください",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "色",
        "色合わせ",
        "西瓜"
      ]
    },
    "ko": {
      "title": "팝 파티",
      "description": "Pop Party, 빠른 속도의 2D 물리학 패ズل 게임으로 돌발적인 전환이 기대됩니다!\n목표는? 볼을 크고 더 나은 버전으로 합쳐내기 전에 유리병이 가득 차지 않도록 합쳐내세요!\n\n파워업의 혼란을 일으키세요!\n게임의 흐름을 six 가지 강력한 능력으로 돌리세요:\n Shak\n 레벨업\n 레벨다운\n 클로\n 폭탄\n 컬러폭탄\n\n동화적인 테마를 해금하세요!\n게임을 진행하면서 독특한 테마를 모아서 볼의 모습을 변환하세요:\n\n혼란을 완전히 통제할 수 있을까요? 승리로 향해 볼을 합쳐내고 모든 테마를 해금하세요?",
      "instructions": "마우스나 터치로 게임 인터페이스와 상호작용하세요",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "색",
        "색맞추기",
        "바나나아이스크림"
      ]
    },
    "fr": {
      "title": "Pop Party",
      "description": "Préparez-vous à la Pop Party, un jeu de puzzle physique 2D rapide et avec un tour de force ! \nVotre objectif ? Fusionnez-les pour créer des versions plus grandes et meilleures avant que votre pot ne déborde ! \n\nBoostez la folie !\nInfluencez le cours du jeu avec six pouvoirs puissants :\nAgiter\nNiveau Up\nNiveau Down\nGriffure\nBombe\nBombe Couleur\n\nDébloquez des Thèmes Étonnants !\nAvancez dans le jeu et collectez des thèmes uniques, chacun transformant l'apparence de vos billes :\n\nPouvez-vous maîtriser le chaos, fusionner votre chemin vers la victoire et débloquer chaque thème ?",
      "instructions": "Utilisez la souris ou le tactile pour interagir avec l'interface de jeu.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "couleur",
        "colormatch",
        "pastèque"
      ]
    }
  }
};
